module.exports = __webpack_public_path__ + "img/Google Logo.dc783842.png";